import { useProperty, useTranslation } from '@eti/providers';
import { constants } from '@eti/utils';

const { priceDisplayTypes } = constants;
const { PER_ADULT, PER_TRAVELER, TOTAL } = priceDisplayTypes;

const usePriceDisplayType = (discountAmount = 0) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const brandedFarePriceDisplayType = p('BrandedFares.ShowPrice.Type') || PER_ADULT;
  const priceDisplayType = discountAmount ? TOTAL : brandedFarePriceDisplayType;

  const priceDisplayTexts = {
    [PER_ADULT]: t('Result.PricePerAdult.Text'),
    [PER_TRAVELER]: t('Result.PricePerPerson.Text'),
    [TOTAL]: t('Result.TotalPrice.Text'),
  };

  const priceToAnnounceTexts = {
    [PER_ADULT]: t('Price.Per.Adult'),
    [PER_TRAVELER]: t('Result.PricePerPerson.Text'),
    [TOTAL]: t('Result.TotalPrice.Text'),
  };
  const priceDisplayText = priceDisplayTexts[priceDisplayType];
  const priceToAnnounceText = priceToAnnounceTexts[priceDisplayType];

  return { priceDisplayType, priceDisplayText, priceToAnnounceText };
};

export default usePriceDisplayType;
